import { Popover, Tooltip } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { SubMenuIconWrapper, SubMenuWrapper, TextLink } from '../Styles/Styles'
import { FaInvoice } from '../../../Images/icon'
import useClickOutside from '../../../../hooks/useClickOutside/useClickOutside'

const permission = JSON.parse(localStorage.getItem("permissions")) || [];

const invoiceAccess = permission.find((o) => o.slug === "invoices");
const creditAccess = permission.find((o) => o.slug === "credits");
const sponsershipAccess = permission.find((o) => o.slug === "sponsor_purchase");

const FinanceSubMenu = () => {

    const hasReadPermissionForInvoices = invoiceAccess?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForCredits = creditAccess?.permissions?.find((o) => o.slug === "read")
    const hasReadPermissionForSponserships = sponsershipAccess?.permissions?.find((o) => o.slug === "read")

    const popoverRef = useRef(null);
    const isOutsideClicked = useClickOutside(popoverRef);

    const [anchorEl, setAnchorEl] = React.useState(null);

    useEffect(() => {
        if (isOutsideClicked) {
            handleClose();
        }
    }, [isOutsideClicked])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    if (!hasReadPermissionForInvoices && !hasReadPermissionForCredits && !hasReadPermissionForSponserships) {
        return null
    }


    return (
        <>
            <Tooltip title='Finance' placement="right">
                <SubMenuIconWrapper
                    onClick={handleClick}
                >
                    <FaInvoice />
                </SubMenuIconWrapper>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
                ref={popoverRef}
            >
                <SubMenuWrapper>
                    {hasReadPermissionForInvoices &&
                        <TextLink to="/invoices" onClick={handleClose}>
                            Invoices
                        </TextLink>
                    }
                    {hasReadPermissionForCredits &&
                        <TextLink to="/credit-history" onClick={handleClose}>
                            Credit History
                        </TextLink>
                    }
                    {hasReadPermissionForSponserships && <TextLink to="/sponsership-history" onClick={handleClose}>
                        Sponsership History
                    </TextLink>}
                </SubMenuWrapper>
            </Popover>
        </>
    )
}

export default FinanceSubMenu